var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"camera-page-header",class:{
    isPC: _vm.$store.getters['camera/isPC'],
    isI18nJa: _vm.$i18n.locale == 'ja',
    isI18nVi: _vm.$i18n.locale == 'vi',
    isI18nEn: _vm.$i18n.locale == 'en',
    isI18nId: _vm.$i18n.locale == 'id',
    isI18nMs: _vm.$i18n.locale == 'ms',
    isI18nTh: _vm.$i18n.locale == 'th',
    isI18nZh: _vm.$i18n.locale == 'zh',
    isAutodetect: _vm.$store.state.camera.isDetectStart
  },attrs:{"data-testid":"camera-page-header"}},[_c('div',{ref:"headerTitle",staticClass:"header-title",style:({
      height: `${_vm.$store.state.camera.headerHeight - 1}px`
    })},[_c('span',{ref:"headerTitleSlot",staticClass:"header-title-inner",class:{ opDoc: _vm.isOpDocPage }},[_vm._t("default")],2)]),(_vm.displayLanguageIcon)?[(_vm.$store.getters['camera/isPC'])?_c('ChangeLanguageIconPc',{staticClass:"page-header-icon-pc"}):_c('ChangeLanguageIconSp',{staticClass:"page-header-icon-sp"})]:_vm._e(),_vm._m(0)],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header-border"},[_c('div',{staticClass:"header-border-line"})])
}]

export { render, staticRenderFns }